export default __webpack_public_path__ + "static/media/vip10-bg.f716b9fd.jpg";